import React, { Component } from 'react';
import SPurchaseSucceeded from 'shared/screens/PurchaseSucceeded';
import Utils from 'shared/utils/index';
import ENVIRONMENT_VARIABLES from 'shared/utils/environmentVariables';
import { getText, TEXT_KEY } from 'shared/utils/localization';

export default class PurchaseSucceeded extends Component {
  static get AsModalProps() {
    return {
      dialogClassName: 'gtp-modal-purchase-succeeded',
    };
  }

  render() {
    return (
      <SPurchaseSucceeded
        navigation={this.props.navigation}
        {...this.props}
        render={args => {
          const { message, buttonHandler, vipPurchase } = args;

          const buttonSrc = vipPurchase
            ? require(asset`images/VIP_Assets/Play_Now_Button@3x.png`)
            : require(asset`images/Purchase_Flow_Assets/Done_Button@3x.png`);
          return (
            <div qa-id="purchaseSuccess" className="SuccessMessageContainer">
              {!vipPurchase && (
                <>
                  <div
                    style={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      fontSize: '3vmin',
                      fontWeight: '500',
                      marginBottom: '3vmin',
                    }}
                  >
                    <span
                      data-label={'PURCHASE SUCCESSFUL'}
                      className={`title ${ENVIRONMENT_VARIABLES.APPLICATION_TARGET}`}
                    >
                      {getText(TEXT_KEY.PURCHASE_SUCCESSFUL)}
                    </span>
                    <img
                      src={require(asset`images/Purchase_Flow_Assets/Light_Divider@3x.png`)}
                      alt=""
                      style={{
                        position: 'absolute',
                        width: '100%',
                        top: '100%',
                        pointerEvents: 'none',
                        left: 0,
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    />
                  </div>
                  <img
                    src={require(asset`images/Purchase_Flow_Assets/Pile_of_Coins@3x.png`)}
                    style={{
                      width: '55%',
                      height: '60%',
                      objectFit: 'contain',
                    }}
                    alt=""
                  />
                  <div className="successHeader">{getText(TEXT_KEY.SUCCESS_RESPONSE)}</div>
                </>
              )}
              {vipPurchase && (
                <>
                  <img
                    className="congratulationsImage"
                    alt="Purchase succeeded"
                    src={require(asset`images/VIP_Assets/Purchase_Succeeded@3x.png`)}
                  />
                  <div style={{ position: 'relative', width: '100%', marginBottom: '1rem' }}>
                    <img
                      alt=""
                      src={require(asset`Light_Divider@3x.png`)}
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        pointerEvents: 'none',
                      }}
                    />
                  </div>
                </>
              )}
              <div className="messageContainer">
                {vipPurchase && <div className="message">{getText(TEXT_KEY.ACCESS_GRANTED)}</div>}
                <div className="message">{message}</div>
              </div>
              <img
                qa-id="purchaseSuccessDoneBtn"
                className={'button' + (Utils.ieVersion() !== 0 ? ' ieHack' : '')}
                src={buttonSrc}
                alt="Done"
                onClick={buttonHandler}
              />
            </div>
          );
        }}
      />
    );
  }
}

PurchaseSucceeded.hideCloseButton = false;

